import _createForOfIteratorHelper from "/builds/hooxitech/polgozar-front-end/packages/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { compute as e } from "compute-scroll-into-view";
var t = function t(e) {
    return "object" == typeof e && "function" == typeof e.behavior;
  },
  o = function o(e) {
    return !1 === e ? {
      block: "end",
      inline: "nearest"
    } : function (e) {
      return e === Object(e) && 0 !== Object.keys(e).length;
    }(e) ? e : {
      block: "start",
      inline: "nearest"
    };
  };
function n(n, l) {
  if (!n.isConnected || !n.ownerDocument.documentElement.contains(n)) return;
  if (t(l)) return l.behavior(e(n, l));
  var i = "boolean" == typeof l || null == l ? void 0 : l.behavior;
  var _iterator = _createForOfIteratorHelper(e(n, o(l))),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _step.value,
        _t = _step$value.el,
        r = _step$value.top,
        c = _step$value.left;
      _t.scroll({
        top: r,
        left: c,
        behavior: i
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
export { n as default };